import React, { useState, useEffect } from 'react';
import LoyaltyItem from '../components/loyalty/LoyaltyItem';
import LoyaltySpecialConditionGroup from '../components/loyalty/LoyaltySpecialConditionGroup';
import LoyaltyFinishModal from '../components/modal/LoyaltyFinishModal';
import '../css/Loyalty.css';
import { useDispatch, useSelector } from 'react-redux';
import { getLoyaltyProducts, getLoyaltySettings } from '../redux/actions/productActions';
import { Modal, Image, Container, Row, Col } from 'react-bootstrap';
import CurrencyFormat from '../components/other/CurrencyFormat';
import { globalStatistic } from '../redux/actions/otherActions';
import ScrollToTop from '../components/other/ScrollToTop';
import PageHelmet from '../components/helmet/PageHelmet';
import { getPageSeo } from '../redux/actions/pageActions';
import Captcha from '../components/other/Captcha';
import LoyaltyCounterBlock from '../components/loyalty/LoyaltyCounterBlock';
import LoyaltyScrollToProductsButton from '../components/loyalty/LoyaltyScrollToProductsButton';
import LoyaltyJokerResultModal from '../components/modal/LoyaltyJokerResultModal';
import LoyaltyTargetSummaryCard from '../components/loyalty/LoyaltyTargetSummaryCard';
import { useTranslation } from 'react-i18next';
import MessageInfoBox from '../components/other/MessageInfoBox';
import { toast } from 'react-toastify';
import axios from 'axios';
import { axiosinstance } from '../configAxios';
// import FlipClock from "x-react-flipclock";
import Countdown, { zeroPad } from 'react-countdown';
import { get } from 'sortablejs';

const LoyaltyShopPage = () => {

    const dispatch = useDispatch();
    // useEffect(() => {
    //     dispatch(getLoyaltyProducts());
    // }, [dispatch]);
    const loyaltyProductsList = useSelector((state) => state.getLoyaltyProducts);
    const loyaltySettings = useSelector((state) => state.getLoyaltySettings);
    const getUserInfo = useSelector((state) => state.userInfo.userInfo.companyAdditionalInfo);
    const getCurrentServerTime = useSelector((state) => state.getCurrentServerTime.items);
    const userInfo = useSelector((state) => state.userInfo);
    // 'isCancelButtonClicked' je stanje koje prati da li je dugme za odustajanje kliknuto.
    // 'null' je početna vrednost, što znači da dugme nije kliknuto.
    // 'setIsCancelButtonClicked' je funkcija koja se koristi za ažuriranje ovog stanja.    
    const [isCancelButtonClicked, setIsCancelButtonClicked] = useState(null);
    // 'shouldAnimat' je stanje koje prati da li treba da se pokrene animacija (pokrece se klikom na ljubicasto polje i klikom na dugme 'Odustani)
    // 'false' je početna vrednost, što znači da animacija neće biti pokrenuta odmah.
    // 'setShouldAnimate' je funkcija koja se koristi za ažuriranje ovog stanja.
    const [shouldAnimate, setShouldAnimate] = useState(false);
    const getB2bSettings = useSelector((state) => state.getB2bSettings);
    // var objArr = {};
    const [show, setShow] = useState(false);
    const [counter, setCounter] = useState(0);
    const [activeShop, setActiveShop] = useState(0);

    const [finishCart, setFinishCart] = useState(false);
    const [emptyValues, setEmptyValues] = useState([]);
    const now = Date.now();
    const [pageSeoData, setPageSeoData] = useState({});
    // Mapa (ne pojedinacna vrednost!) kljucevanih po composite groupItemKey - ako bi ovo bila samo
    // JEDNA vrednost, klik u drugom Condition-u bi je prepisao i "zatvorio" karticu otvorenu u prvom.
    const [clickedSpecialItems, setClickedSpecialItems] = useState({});
    // Mapa kljuceva koji su "otkazani" (Odustani) - vraca IZGLED te konkretne kartice na "?", ali
    // NE dira clickedSpecialItems, pa ceo Condition ostaje trajno zakljucan i posle otkazivanja.
    const [canceledItems, setCanceledItems] = useState({});
    // 'Kupovina je otkazana' modal (LoyaltyJokerResultModal) - null = ne prikazuj, inace 'Deal'/
    // 'Super' (tier ciji je Odustani upravo kliknut). Zivi ovde (ne u LoyaltySpecialItem.js) - vidi
    // komentar u handleCancelButtonClick ispod.
    const [jokerCanceledTier, setJokerCanceledTier] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [res, setRes] = useState();
    const [socketResponse, setSocketResponse] = useState([]);
    // Potvrdjene kupovine po grupi, kljuc je composite groupItemKey (${anConditionId}_${key}) -
    // ne globalni bool/objekat, da uspesna kupovina u jednom Condition-u ne "iscuri" u drugi
    // kad korisnik odmah zatim klikne artikal iz druge grupe.
    const [confirmedPurchases, setConfirmedPurchases] = useState({});
    const [clickedItemData, setClickedItemData] = useState(null);
    const adLoyaltyStartDate = Date.parse(loyaltySettings.adLoyaltyStartDate)
    const adLoyaltyEndDate = Date.parse(loyaltySettings.adLoyaltyEndDate)
    const { t } = useTranslation('loyaltyShopPage');

    const [hideModal, setHideModal] = useState(false);
    // New useEffect for WebSocket logic
    useEffect(() => {
        let socket;
        // if (loyaltyProductsList.isSpecialOpen !== 0) { // proveriti 20.06.2024.
        socket = socketFunction();
        // }
        return () => {
            if (socket) {
                socket.removeEventListener('message', handleMessageFromServer);
                if (socket.readyState === WebSocket.OPEN) {
                    socket.close();
                }
            }
        };
    }, [loyaltyProductsList, loyaltySettings]);

    const handleCancelButtonClick = (key, tier) => {
        setIsCancelButtonClicked(key);
        setConfirmedPurchases(prev => {
            const next = { ...prev };
            delete next[key];
            return next;
        });
        // vraca izgled BAS ove kartice na "?" - ne dira clickedSpecialItems, pa ceo Condition
        // ostaje zakljucan (nista se ne moze kliknuti) i posle otkazivanja
        setCanceledItems(prev => ({ ...prev, [key]: true }));
        setTimeout(() => {
            setShouldAnimate(false);
            // isCancelButtonClicked se mora resetovati - inace ostaje trajno zapamcen taj kljuc, i
            // moze slucajno da se poklopi sa DRUGOM karticom koja kasnije postane otvorena (npr. jer
            // joj je acBuyer stvarno popunjen), izazivajuci pogresnu "flipflip-reverse" klasu na njoj.
            setIsCancelButtonClicked(null);
        }, 2000);
        // setClickedSpecialItem(key);
        // console.log('[DEBUG odustani] otkazujem kljuc:', key, '- ovo pokrece dispatch(getLoyaltyProducts(1)), sto ponovo pokrece socket useEffect (jer loyaltyProductsList ide u njegove zavisnosti) - moze da donese svez socket push za SVE Condition-e odjednom');
        dispatch(getLoyaltyProducts(1));

        // Modal "Kupovina je otkazana" (LoyaltyJokerResultModal) MORA ziveti ovde, na vrhu (ne u
        // LoyaltySpecialItem.js) - setCanceledItems iznad odmah cini da isItemOpen (racunato u
        // LoyaltySpecialConditionGroup.js) padne na false za BAS OVU karticu, sto UNMOUNT-uje
        // LoyaltySpecialItem (za Deal/Super, koji nisu alwaysOpen - Premium nema Odustani).
        // Bilo koje lokalno state ("prikazi canceled modal") postavljeno UNUTAR te komponente bi
        // nestalo tacno u trenutku kad treba da se prikaze - zivo potvrdjeno, modal se nikad nije
        // pojavljivao za Deal (ni Super, samo jos nije bilo primeceno).
        const tierKey = tier ? tier.toLowerCase() : null;
        if (tierKey === 'deal' || tierKey === 'super') {
            setJokerCanceledTier(tier);
        }
    };

    const handleCloseJokerCanceledModal = () => {
        setJokerCanceledTier(null);
    };


    const handleClose = () => {
        setShow(false);
    };
    const handleSubmit = (event) => {
        event.preventDefault();
        setShow(true);
    }


    const renderButtonSubmitLoyalty = () => {
        if (getUserInfo.acCompanyLoyaltyStatus && (getUserInfo.acCompanyLoyaltyStatus.trim().toUpperCase() != 'CRVEN' && loyaltySettings.anCompanyTarget < loyaltySettings.anCompanyTargetAchieved && activeShop == 1 && (adLoyaltyStartDate <= now && adLoyaltyEndDate >= now))) {

            return (
                <div className={`${emptyValues.length == 0 || emptyValues.filter(i => i.value == 0).length > 0 ? "button-submit-ly-shop-disabled" : ""} button-submit-ly-shop`}>
                    <button type="submit" className="btn btn-success" disabled={emptyValues.length == 0 || emptyValues.filter(i => i.value == 0).length > 0 ? true : false} onClick={(e) => handleSubmit(e)} title={emptyValues.length == 0 || emptyValues.filter(i => i.value == 0).length > 0 ? t('validacija') : ""}><i className="fa fa-shopping-cart" aria-hidden="true"></i>&nbsp; {t('dugme')}</button>
                </div>
            );
        }
    };


    const setActiveShopFunction = (val) => {
        setActiveShop(val);
    };
    const handleItemClick = async (itemId, anLoyaltyTypeId, anConditionId, key) => {//ovde cu proslediti parametre koje velja ocekuje za kliknut item
        setClickedSpecialItems(prev => ({ ...prev, [key]: true }));
        // handleSpecialItemClick(key);

        setShouldAnimate(true);
        setIsCancelButtonClicked(null);
        const attributes = {};
        attributes['anCompanyKey'] = userInfo.userInfo.company.anCompanyKey;
        attributes['anLoyaltyTypeId'] = anLoyaltyTypeId;
        attributes['anConditionId'] = anConditionId;
        attributes['anSpecialProductKey'] = itemId;

        // const responseData1 = {
        //     "_id": 1324868,
        //     "anCompanyKey": 1789,
        //     "anProductKey": 8499,
        //     "acProduct": "MON02957",
        //     "acProductName": "DAHUA 22 inča FHD Monitor LM22-A200",
        //     "acLoyaltyGroup": "Monitori i oprema             ",
        //     "anLoyaltyGroupOrdering": 4,
        //     "anPrice": 60.0,
        //     "anOldPrice": 60.62800000000001,
        //     "anQty": 1,
        //     "anQtyVirtual": 1,
        //     "anQtyAvailableForCompany": 1,
        //     "isPriceVisible": 1,
        //     "isSpecialForCompany": 0,
        //     "isSaleConnected": 0,
        //     "acConditionType": "UslovljenaProdaja",
        //     "anProductId": 6404,
        //     "anLoyaltyTypeId": 1
        // };


        const configRes = axiosinstance(attributes, '8224', 'postCompanyLoyalityShopSpecialLog');

        axios(configRes)
            .then(function (response) {
                // console.log('[DEBUG canClick:1] odgovor na klik (ceo response.data.response):', response.data.response);
                if (response.data.response.isOk === 1) {
                    setConfirmedPurchases(prev => ({ ...prev, [key]: response.data.response.setLoyaltyShopProduct }));
                } else {
                    toast(<MessageInfoBox message={response.data.response.acMsg} type="0" />, {
                        className: 'red-background',
                    });
                    // Oslobodi kljuc (isto kao na mreznu gresku) - ne zakljucavaj karticu trajno na
                    // odbijanje. Umesto toga, pusti da sledeci REST/socket podaci (canClick/isReached)
                    // sami odrede stvarno stanje: ako je odbijanje bila greska/race, korisnik odmah
                    // ponovo vidi klikabilnu "?" karticu; ako je pravo stvarno vec iskorisceno (neko
                    // drugi ga je uzeo u medjuvremenu), grupa ispravno padne na Prikaz 3 ("Nivo je
                    // iskoriscen") umesto da kartica ostane trajno prazna i zaglavljena.
                    setClickedSpecialItems(prev => {
                        const next = { ...prev };
                        delete next[key];
                        return next;
                    });
                }
            })
            .catch(function (error) {
                console.error(error);
                toast(<MessageInfoBox message="greskaKomunikacije" type="0" />, {
                    className: 'red-background',
                });
                // mrezna greska (ne odbijanje od servera) - oslobodi SAMO ovaj kljuc, ne diraj ostale
                setClickedSpecialItems(prev => {
                    const next = { ...prev };
                    delete next[key];
                    return next;
                });
            });
    };

    //ako je isSpecialOpen!==0 onda se okida socket kako bismo znali da li je neki product u medjuvremenu prodat ili nije, ako jeste onda otvaram taj product i prikayujem info o tome da je kupljeno i ko je kupio


    const handleMessageFromServer = (event) => {
        const message = event.data;
        // console.log('[DEBUG handleMessageFromServer] stigla poruka:', message);
        try {
            const parsedMessage = JSON.parse(message);
            // console.log('[DEBUG handleMessageFromServer] parsirana poruka:', parsedMessage);
            setSocketResponse(parsedMessage);
        } catch (error) {
            console.error('error:', error);
        }
    };

    const socketFunction = () => {
        const data = {
            anCompanyKey: userInfo.userInfo.company.anCompanyKey,
            anLoyaltyType: loyaltySettings.anLoyaltyTypeId
        };
        // console.log('[DEBUG socketFunction] anLoyaltyTypeId:', data.anLoyaltyType, 'anCompanyKey:', data.anCompanyKey);
        if (data.anLoyaltyType !== undefined) {
            const socketBase = (process.env.REACT_APP_API_URL || '').replace(/^http/, 'ws');
            const url = `${socketBase}/specialProductLoyality/${data.anCompanyKey},${data.anLoyaltyType}`;
            // console.log('[DEBUG socketFunction] pokusavam konekciju na:', url);
            const socket = new WebSocket(url);

            socket.addEventListener('open', function (event) {
                // console.log('[DEBUG socketFunction] WebSocket OTVOREN:', event);
            });

            socket.addEventListener('message', handleMessageFromServer);

            socket.addEventListener('close', function (event) {
                // console.log('[DEBUG socketFunction] WebSocket ZATVOREN:', event.code, event.reason);
            });

            socket.addEventListener('error', function (error) {
                console.error('WebSocket greška:', error);
            });
            return socket;
        } else {
            // console.log('[DEBUG socketFunction] anLoyaltyTypeId je undefined - socket se NE otvara');
        }
    };

    useEffect(() => {
        dispatch(getPageSeo(766)).then(res => {
            if (res) {
                setPageSeoData(res);
            }
        });

        dispatch(getLoyaltyProducts(1));
        dispatch(getLoyaltySettings(1));
        dispatch(globalStatistic(766, 'PAGE'));

    }, [dispatch, userInfo.userInfo.company.anCompanyKey]);

    // Socket je izvor istine kad god je dostavio poruku (nosi obogacene artikle po grupi);
    // pre prve socket poruke koristimo REST-loaded grupe (goli ID-jevi, dovoljno za zakljucane kartice).
    const hasSocketData = !!(socketResponse && socketResponse.specialShopListGroup);
    // Sortiramo po pragu (anConditionLimit, rastuce) - nivo (Deal/Super/Premium) se odredjuje po
    // POZICIJI u nizu, a backend NE garantuje redosled grupa (zivo potvrdjeno 2026-10-23: poslao
    // 79/8888 pre 73/1888, pa su Deal i Super zamenili mesta). Najnizi prag je uvek Deal.
    const specialConditionGroups = [...(hasSocketData ? socketResponse.specialShopListGroup : (loyaltyProductsList.specialShopListGroup || []))]
        .sort((a, b) => (a.anConditionLimit ?? 0) - (b.anConditionLimit ?? 0));
    const specialConditionGroupsLng = specialConditionGroups.length > 0;
    // Nezavisna odbrana kao i pre - ako Loyalty program formalno nije aktivan (van perioda),
    // specijalna sekcija se prikazuje iskljucivo kao zakljucana, bez obzira sta canClick kaze.
    const isShopActive = loyaltySettings.isActive;

    // Grid blokovi (mode="grid") NISU vise prost redosled niza - Super i Premium dele gornji red
    // (Super 2/3, Premium 1/3 sirine, iste razmere kao summary red iznad), Deal ide u svoj PUN red
    // ispod, isto kao i svaki naredni (4+) nivo. colorIndex ostaje njegova STVARNA pozicija u nizu
    // (specialConditionGroups[1] je UVEK Super, bez obzira gde se vizuelno prikazuje) - inace bi
    // pogresno izvukao ime/boje/sliku drugog nivoa iz TIER_NAMES/TIER_CARDS.
    const renderGridBlock = (condition, idx) => (
        <LoyaltySpecialConditionGroup
            key={condition.anConditionId}
            condition={condition}
            colorIndex={idx}
            getB2bSettings={getB2bSettings}
            handleCancelButtonClick={handleCancelButtonClick}
            clickedSpecialItems={clickedSpecialItems}
            canceledItems={canceledItems}
            isCancelButtonClicked={isCancelButtonClicked}
            setShouldAnimate={setShouldAnimate}
            finishCart={finishCart}
            shopIsActive={activeShop}
            isShopActive={isShopActive}
            isLive={hasSocketData}
            getUserInfo={getUserInfo}
            loyaltySettings={loyaltySettings}
            confirmedPurchases={confirmedPurchases}
            setEmptyValues={setEmptyValues}
            emptyValues={emptyValues}
            setFinishCartFunction={setFinishCart}
            onItemClick={handleItemClick}
            mode="grid"
        />
    );

    return (
        <>
            {Object.keys(pageSeoData).length !== 0 &&
                <PageHelmet
                    title={pageSeoData ? `${pageSeoData.acSeoTitle}` : "Ewe Comp"}
                    description={pageSeoData ? `${pageSeoData.acSeoDescription}` : ""}
                    keywords={pageSeoData ? `${pageSeoData.acSeoKeywords}` : ""}
                    ogDescription={pageSeoData ? `${pageSeoData.acSeoDescription}` : ""}
                    ogTitle={pageSeoData ? `${pageSeoData.acSeoTitle}` : ""}
                    ogUrl={pageSeoData ? `https://ewe.rs/${pageSeoData.acSeoUrl}` : ""}
                    ogImg="https://www.ewe.rs/media/ewe-og-img.jpg"
                    twitterDescription={pageSeoData ? `${pageSeoData.acSeoDescription}` : ""}
                />
            }
            {loyaltySettings.length != 0 && (
                <div className="container-content container-main-content target-content loyalty-shop-content-container">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-12">
                                <LoyaltyCounterBlock loyaltySettings={loyaltySettings} setActiveShopFunction={setActiveShopFunction} activeShop={activeShop} />
                            </div>

                            {loyaltySettings.anCompanyTarget > 0 ? (
                                <>
                                    {/* {(
                                    <div className="col-sm-12">
                                        <div className="loyaty-holder-info-user-box">
                                            <div className="loyalty-info-box-item">
                                                <h1>{t('naslov1')}</h1>
                                                {loyaltySettings.anLoyaltyTargetPercentRemain > 0 ? (
                                                    <>
                                                        <div className="total-sum-percent-loyalty">{loyaltySettings.anLoyaltyTargetPercentRemain}%</div>
                                                        <div className="scala-holder-loyalty">
                                                            {loyaltySettings.anLoyaltyTargetPercentRemain == 0 ? (
                                                                <>
                                                                    <div className="scala-holder-loyatly-left" style={{ width: `calc(0% + 17px)` }}></div>
                                                                    <div className="scala-holder-loyatly-right"></div>
                                                                    <div className="scala-holder-loyalty-circle" style={{ left: `0%` }}></div>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <div className="scala-holder-loyatly-left" style={{ width: `calc(${100 - loyaltySettings.anLoyaltyTargetPercentRemain}% + 17px)` }}></div>
                                                                    <div className="scala-holder-loyatly-right"></div>
                                                                    <div className="scala-holder-loyalty-circle" style={{ left: `${100 - loyaltySettings.anLoyaltyTargetPercentRemain}%` }}></div>
                                                                </>
                                                            )}
                                                        </div>
                                                        <div className="scala-holder-numers">
                                                            <div className="scala-holder-number-item scala-holder-number-item">0</div>
                                                            <div className="scala-holder-number-item scala-holder-number-item-25">25</div>
                                                            <div className="scala-holder-number-item scala-holder-number-item-50">50</div>
                                                            <div className="scala-holder-number-item scala-holder-number-item-75">75</div>
                                                            <div className="scala-holder-number-item scala-holder-number-item-100">100</div>
                                                        </div>
                                                        <span className="shop-target-description-loyalty">{t('paragraf1')}</span>
                                                    </>
                                                ) : (
                                                    <>
                                                        <i className="fas fa-check"></i>
                                                        <span className="shop-target-description-loyalty shop-target-description-loyalty-second">{t('paragraf2')}</span>
                                                    </>
                                                )}
                                            </div>
                                            <div className="loyalty-info-box-item">
                                                <p>{t('paragraf3')}</p>
                                                <div className="total-sum-percent-loyalty">{loyaltySettings.anLoyaltyTargetPacePrediction}%</div>
                                                <span className="shop-target-description-loyalty shop-target-description-loyalty-second">{t('paragraf4')}</span>
                                            </div>
                                            <div className="loyalty-info-box-item">
                                                <div className="bottom-divider">
                                                    <div className="loyalty-upper-desc">{t('paragraf5')}</div>
                                                    <div className="stat-target red"><CurrencyFormat num={loyaltySettings.anCompanyTarget} /> <small>EUR</small></div>
                                                    <div className="loyalty-upper-desc">{t('paragraf6')}</div>
                                                    <div className="stat-target green"><CurrencyFormat num={loyaltySettings.anCompanyTargetAchieved} /> <small>EUR</small></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    )} */}

                                    {loyaltyProductsList.isSaleConnected == 1 && (
                                        <div className="col-lg-12">
                                            <div className="info-icons-action">
                                                <span>{t('paragraf7')}</span> <img alt={t('bedz')} className="smallBadge" src="/images/loyalty/badges-povezana-prodaja.png" /> <span>{t('paragraf8')}</span> <img alt={t('bedz')} className="smallBadge" src="/images/loyalty/badges-povezana-prodaja-artikal.png" /> <span>{t('paragraf9')}</span>
                                            </div>
                                        </div>
                                    )}
                                    {getUserInfo.acCompanyLoyaltyStatus.trim().toUpperCase() == 'CRVEN' &&
                                        <div className="col-sm-12">
                                            <div className="alert alert-danger w-100 alert-info-loyalty" role="alert">
                                                {t('paragraf10')}
                                            </div>
                                        </div>
                                    }

                                    {/* Summary kartice (Deal/Super/Premium JOKER) izdvojene iz blokova ispod - jedan
                                        red, po trecinu svaka na desktopu, jedna ispod druge na mobilnom (.joker-summary-row
                                        u Loyalty.css). Svaka i dalje racuna svoje stanje (isForcedLocked...) nezavisno -
                                        mode="summary" samo bira DA SE PRIKAZE samo taj deo, ne dupliraj logiku. */}
                                    {specialConditionGroupsLng && (
                                        <div className="col-sm-12">
                                            <div className="joker-summary-row">
                                                {/* Prva "kolona" - obican target/promet (postCompanyLoyalitySettings),
                                                    NIJE deo Deal/Super/Premium ponude - vidi LoyaltyTargetSummaryCard.js.
                                                    NAMERNO pun red (joker-summary-slot-target, flex-basis:100%) umesto
                                                    trecine kao ostale kartice - Deal/Super/Premium MORAJU ostati na
                                                    tacno 1/3 (.joker-summary-slot, nedirano) da se poklope sa
                                                    Super/Premium kolonama u detalj-mrezi ispod (.joker-grid-top-row) -
                                                    da je Target "cetvrta trecina" pokvario bi TO poravnanje. */}
                                                <div className="joker-summary-slot joker-summary-slot-target">
                                                    <LoyaltyTargetSummaryCard loyaltySettings={loyaltySettings} />
                                                </div>
                                                {specialConditionGroups.map((condition, idx) => (
                                                    <LoyaltySpecialConditionGroup
                                                        key={condition.anConditionId}
                                                        condition={condition}
                                                        colorIndex={idx}
                                                        getB2bSettings={getB2bSettings}
                                                        handleCancelButtonClick={handleCancelButtonClick}
                                                        clickedSpecialItems={clickedSpecialItems}
                                                        canceledItems={canceledItems}
                                                        isCancelButtonClicked={isCancelButtonClicked}
                                                        setShouldAnimate={setShouldAnimate}
                                                        finishCart={finishCart}
                                                        shopIsActive={activeShop}
                                                        isShopActive={isShopActive}
                                                        isLive={hasSocketData}
                                                        getUserInfo={getUserInfo}
                                                        loyaltySettings={loyaltySettings}
                                                        confirmedPurchases={confirmedPurchases}
                                                        setEmptyValues={setEmptyValues}
                                                        emptyValues={emptyValues}
                                                        setFinishCartFunction={setFinishCart}
                                                        onItemClick={handleItemClick}
                                                        mode="summary"
                                                    />
                                                ))}
                                            </div>
                                        </div>
                                    )}

                                    {specialConditionGroupsLng && (() => {
                                        const dealCond = specialConditionGroups[0];
                                        const superCond = specialConditionGroups[1];
                                        const premiumCond = specialConditionGroups[2];
                                        const restConds = specialConditionGroups.slice(3);
                                        // Deal/Super/Premium su sad SVI unutar iste .joker-grid-top-row grid mreze
                                        // (Deal span-uje sve 3 kolone pa automatski upada u svoj PUN red ispod
                                        // Super+Premium na desktopu, identicno prethodnom izgledu) - potrebno da bi
                                        // mobilni CSS "order" (.joker-tier-*, Loyalty.css) mogao da presloži redosled
                                        // (Premium, Super, Deal) izmedju sve tri kartice, koje CSS "order" moze da
                                        // menja SAMO medju direktnom decom istog grid/flex kontejnera.
                                        const hasTopRow = !!(dealCond || superCond || premiumCond);
                                        return (
                                            <>
                                                {hasTopRow && (
                                                    <div className="col-sm-12">
                                                        <div className="joker-grid-top-row">
                                                            {superCond && (
                                                                <div className={`joker-tier-super ${premiumCond ? 'joker-grid-col-wide' : 'joker-grid-col-full'}`}>
                                                                    {renderGridBlock(superCond, 1)}
                                                                </div>
                                                            )}
                                                            {premiumCond && (
                                                                <div className="joker-tier-premium joker-grid-col-narrow">
                                                                    {renderGridBlock(premiumCond, 2)}
                                                                </div>
                                                            )}
                                                            {dealCond && (
                                                                <div className="joker-tier-deal joker-grid-col-full">
                                                                    {renderGridBlock(dealCond, 0)}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                                {restConds.map((condition, i) => renderGridBlock(condition, i + 3))}
                                            </>
                                        );
                                    })()}

                                    <div className="col-sm-12">
                                        <div className="loyalty-table-content" id="loyalty-products-table">
                                            <form id="form-loyalty-shop">
                                                <table className="table table-loyalty">
                                                    <thead>
                                                        <tr>
                                                            <th className="text-align-center" style={{ width: '100px' }}>{t('kolona1')}</th>
                                                            <th>{t('kolona2')}</th>
                                                            <th>{t('kolona3')}</th>
                                                            <th>{t('kolona4')}</th>
                                                            <th className="text-align-right">{t('kolona5')}</th>
                                                            <th className="text-align-right">{t('kolona6')}</th>
                                                            <th className="text-align-right">{t('kolona7')}</th>
                                                            <th className="text-align-right">{t('kolona8')}</th>
                                                            <th>{t('kolona9')}</th>
                                                            <th style={{ width: '100px' }}>{t('kolona10')}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {loyaltyProductsList.companyLoyalityShop && loyaltyProductsList.companyLoyalityShop.map((item, key) => (
                                                            item.loyaltyShopItemList.length !== 0 ? (
                                                                <React.Fragment key={key}>
                                                                    <tr className="custom-name-title">
                                                                        <td colSpan={10}>
                                                                            {item.acLoyaltyGroup === '' ? (
                                                                                <div className="loyalty-header-info-products">{t('paragraf11')}</div>
                                                                            ) : (
                                                                                <div className="loyalty-header-info-products">{item.acLoyaltyGroup}</div>
                                                                            )}
                                                                        </td>
                                                                    </tr>

                                                                    {item.loyaltyShopItemList.map((item2, key2) => (
                                                                        <LoyaltyItem finishCart={finishCart} key={key2} keyItem={key2} shopIsActive={activeShop} getUserInfo={getUserInfo} loyaltySettings={loyaltySettings} item={item2} setEmptyValues={setEmptyValues} emptyValues={emptyValues} />
                                                                    ))}
                                                                </React.Fragment>
                                                            ) : null
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </form>
                                            {renderButtonSubmitLoyalty()}
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <div className="col-sm-12">
                                    <div className="alert alert-danger w-100 alert-info-loyalty" role="alert">
                                        {t('paragraf12')}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div >
            )}
            {loyaltySettings.anCompanyTarget > 0 && <LoyaltyScrollToProductsButton />}
            <ScrollToTop />
            <Modal
                show={show}
                onHide={handleClose}
                keyboard={false}
                dialogClassName={`modal-xl loyalty-confirm-modal ${hideModal ? 'closeLoyModal' : 'closeLoyModalHidden'}`} // Dodajemo klasu na osnovu hideModal stanja
                aria-labelledby=""
                centered
            >
                <div className="close-action-modal" variant="secondary" onClick={handleClose}>
                    <i className="far fa-times-circle"></i>
                </div>
                <Modal.Header>
                    <h4>{t('naslov2')}</h4>
                </Modal.Header>
                <Modal.Body>
                    <Captcha setHideModal={setHideModal} setFinishCartFunction={setFinishCart} finishCart={finishCart} handleClose={handleClose} setEmptyValues={setEmptyValues} type={1} start={loyaltySettings.adLoyaltyStartDate} end={loyaltySettings.adLoyaltyEndDate} socketResponse={socketResponse} />
                </Modal.Body>
            </Modal>
            <LoyaltyJokerResultModal
                show={!!jokerCanceledTier}
                onClose={handleCloseJokerCanceledModal}
                tier={jokerCanceledTier}
                variant="canceled"
            />
        </>
    )
}

export default LoyaltyShopPage;